module.exports = __webpack_public_path__ + "static/media/steamcouture-4.f31752fa.jpg";